import React, { useEffect } from 'react';
import { uniqueId } from 'lodash';
import { StyledTabs, StyledTab, Container } from 'components/ToggleTabs/style';

export interface ToggleTabsProps {
  children?: React.ReactNode[];
  labels: string[];
  currentTabIndex: number;
  onTabClick?: Function;
  isBasicManagement?: boolean;
  colors?: any;
}

const ToggleTabs: React.FC<ToggleTabsProps> = (props): JSX.Element => {
  const { currentTabIndex, children, labels, colors, onTabClick } = props;

  const [currentTab, setCurrentTab] = React.useState<number>(currentTabIndex);
  useEffect(() => {
    if (onTabClick) onTabClick(currentTab);
    setCurrentTab(currentTabIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabIndex, onTabClick]);

  const handleChangeTab = (event: React.ChangeEvent<{}>, newTab: number) => {
    if (!props.isBasicManagement) {
      if (onTabClick) onTabClick(currentTab);
      setCurrentTab(newTab);
    }
  };
  return (
    <Container>
      <StyledTabs value={currentTab} onChange={handleChangeTab}>
        {React.Children.toArray(children).map((_, index) => (
          <StyledTab
            key={uniqueId('sahamtab')}
            label={labels[index]}
            style={{
              ...(!!colors &&
                !!colors[index] && { backgroundColor: colors[index] }),
            }}
          />
        ))}
      </StyledTabs>
      {React.Children.toArray(children)[currentTab]}
    </Container>
  );
};

export default ToggleTabs;
